import {ActiveFilter, dateRangeLabel, namesLabel} from '../../designSystem/filterChips';
import type {ContactFilters} from './ContactsFilterPanel';

export type ContactFilterKey = 'shared' | 'sources' | 'date';

const SOURCE_LABELS: Record<string, string> = {
    SYSTEM: 'System',
    PIPEDRIVE: 'Pipedrive',
    DEVICE: 'SIM',
};

export function activeContactFilters(filters: ContactFilters | null): ActiveFilter<ContactFilterKey>[] {
    if (!filters) return [];
    const active: ActiveFilter<ContactFilterKey>[] = [];
    const sharedNames = [...(filters.sharedForUserNames ?? []), ...(filters.sharedForGroupNames ?? [])];
    const sharedCount = filters.sharedForUsers.length + filters.sharedForGroups.length;
    if (sharedCount) {
        active.push({
            key: 'shared',
            label: sharedNames.length ? `Shared with ${namesLabel(sharedNames)}` : `Shared with ${sharedCount}`,
        });
    }
    if (filters.sources?.length) {
        active.push({key: 'sources', label: filters.sources.map((s) => SOURCE_LABELS[s] ?? s).join(', ')});
    }
    if (filters.dateFrom || filters.dateTo) {
        active.push({key: 'date', label: filters.dateLabel || dateRangeLabel(filters.dateFrom, filters.dateTo)});
    }
    return active;
}

/** Removes one category; returns null when nothing is left so the list is unfiltered. */
export function withoutContactFilter(filters: ContactFilters, key: ContactFilterKey): ContactFilters | null {
    const next: ContactFilters = {...filters};
    if (key === 'shared') {
        next.sharedForUsers = [];
        next.sharedForGroups = [];
        next.sharedForUserNames = [];
        next.sharedForGroupNames = [];
    }
    if (key === 'sources') next.sources = undefined;
    if (key === 'date') {
        next.dateFrom = undefined;
        next.dateTo = undefined;
        next.dateLabel = undefined;
    }
    return activeContactFilters(next).length ? next : null;
}
